
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16 4c6.616 0 12 5.384 12 12s-5.384 12-12 12S4 22.616 4 16 9.384 4 16 4zm0 2C10.465 6 6 10.465 6 16s4.465 10 10 10 10-4.465 10-10S21.535 6 16 6zm-4.5 6a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0111.5 12zm9 0a1.5 1.5 0 11-.001 3.001A1.5 1.5 0 0120.5 12zM16 18c2.667 0 5.02 1.335 6.469 3.344L20.844 22.5C19.752 20.986 18.009 20 16 20s-3.752.986-4.844 2.5l-1.625-1.156C10.979 19.336 13.332 18 16 18z"}})])
          )
        }
      }
    